export default __webpack_public_path__ + "images/997f8976b71bde8688d9940431469b52-painting_small.webp";